import React, { useEffect, useState, useRef } from 'react';
import ModalContent from '/Foundation/Common/code/Views/Foundation/Common/ModalContent';
import Spinner from '/Foundation/React/code/Components/Extranet/Spinner';
import { SIGNUP_SOURCE_CART } from '../../../../../../AdobeAnalytics/code/Views/Feature/AdobeAnalytics/Constants/SignupSource.js';

const SparePartAddToCartButton = ({
  sparePart,
  addToCart,
  translations,
  servicePartsModalLink,
  itemResponseData,
  isKeysAndLocks,
  inventory,
}) => {
  const isExtranet = window._THULEDATA.SitecoreSiteName === 'Extranet';
  if (!sparePart?.Id || (!isExtranet && !window._THULEDATA.isB2CEnabled)) return null;

  const [amount, setAmount] = useState(1);
  const [showServicePartModal, setShowServicePartModal] = useState(false);
  const [showServicePartRepairModal, setShowServicePartRepairModal] = useState(false);
  const [isPurchasable, setIsPurchasable] = useState(sparePart.ButtonType == 'Purchasable');
  const [purchasableButton, setPurchasableButton] = useState(
    // Set initial loading state
    <button className="cartButton btn btn-sm thule-btn-default" disabled={true}>
      <div>
        <Spinner />
      </div>
    </button>
  );

  const input = useRef();

  useEffect(() => {
    if (!isNaN(amount)) return;
  }, [amount]);

  useEffect(() => {
    if (!isExtranet) return;
    const isValidResponseForItem =
      itemResponseData && !itemResponseData.Error && itemResponseData.HasSalesPrice && itemResponseData.DeliveryDate
        ? true
        : false;
    setIsPurchasable(isValidResponseForItem);
  }, [itemResponseData]);

  useEffect(() => {
    if (sparePart?.ButtonType === 'Purchasable' && !isExtranet) {
      // use inventory prop instead of fetching here
      if (!inventory) {
        // still show loading until parent sets inventory
        setPurchasableButton(
          <button className="cartButton btn btn-sm thule-btn-default" disabled={true}>
            <div>
              <Spinner />
            </div>
          </button>
        );
        return;
      }

      if (inventory.notBuyable) {
        setPurchasableButton(
          <button className="cartButton btn btn-sm thule-btn-default" disabled={true}>
            {translations.NotBuyable}
          </button>
        );
      } else if (inventory.isInStock) {
        setPurchasableButton(
          <div className="product-add-to-cart">
            <button onClick={(e) => onClickAddToCart(e)} className="cartButton btn btn-sm thule-btn-default">
              {translations.AddToCart}
            </button>
            <span
              className="analyticsData"
              data-customsource={
                isKeysAndLocks ? SIGNUP_SOURCE_CART.KEYS_AND_LOCKS_LIST : SIGNUP_SOURCE_CART.SPARE_PARTS_LIST
              }
            ></span>
          </div>
        );
      } else {
        let atpDateFormatted;
        if (inventory.availabilityDate) {
          atpDateFormatted = new Date(inventory.availabilityDate).toLocaleDateString(
            window._THULEDATA.SitecoreLanguage,
            { day: '2-digit', month: 'long', year: 'numeric' }
          );
        }
        setPurchasableButton(
          <>
            <button className="cartButton btn btn-sm thule-btn-default" disabled={true}>
              {translations.OutOfStock}
            </button>
            {atpDateFormatted && (
              <span className="paragraph--xs">
                {translations.EstimatedAvailability} {atpDateFormatted}
              </span>
            )}
          </>
        );
      }
    }
  }, [inventory, sparePart, translations, isExtranet]);

  const getExtranetButtonContent = () => {
    if (!itemResponseData)
      return (
        <div>
          <Spinner />
        </div>
      );
    if (!itemResponseData.DeliveryDate) return translations?.OutOfStock;
    if (isPurchasable) return translations?.AddToCart;
    return null;
  };

  const onClickAddToCart = (e) => {
    if (!isPurchasable) return;
    addToCart(sparePart, amount, e.target, itemResponseData);
  };

  const getButtonBasedOnType = (sparePart) => {
    if (isExtranet) {
      return (
        <button
          onClick={(e) => onClickAddToCart(e)}
          className={`cartButton btn btn-sm thule-btn-default ${!itemResponseData ? 'pe-none' : ''}`}
        >
          {getExtranetButtonContent()}
        </button>
      );
    }

    switch (sparePart?.ButtonType) {
      case 'ServicePart':
        return (
          <button
            onClick={() => {
              setShowServicePartModal(true);
            }}
            className="cartButton btn btn-sm thule-btn-tertiary"
          >
            <i className="le-icon-info me-3"></i>
            {translations.ModalHeader}
          </button>
        );
      case 'ServicePartRepair':
        return (
          <button
            onClick={() => {
              setShowServicePartRepairModal(true);
            }}
            className="cartButton btn btn-sm thule-btn-tertiary"
          >
            <i className="le-icon-info me-3"></i>
            {translations.ServicePartsRepairHeader}
          </button>
        );
      case 'Purchasable':
        return purchasableButton;
      case 'Unavailable':
        return null;
      case 'Discontinued':
        return <div className="discontinued heading6 text-color--pitchBlack">{translations.Discontinued}</div>;
      default:
        return null;
    }
  };

  return (
    <div className={`sparePartAddToCartButton ${isExtranet ? 'extranet' : ''}`}>
      {isExtranet && (
        <div className="d-flex position-relative sparePartAddToCartButton__inputWrapper">
          <button
            disabled={!isPurchasable}
            onClick={(e) => setAmount(amount > 1 ? amount - 1 : amount)}
            className="btn decrement px-3"
          >
            <i className="le-icon-minus"></i>
          </button>
          <input
            disabled={!isPurchasable}
            ref={input}
            type="number"
            step="1"
            min="1"
            pattern="\d+"
            value={amount}
            onChange={(e) => setAmount(e.currentTarget.value)}
            id={`sparePartAddToCartButton_input_${sparePart.ErpOutdoor}`}
          />
          <button
            disabled={!isPurchasable}
            onClick={(e) => {
              setAmount(amount + 1);
            }}
            className="btn increment px-3"
          >
            <i className="le-icon-plus"></i>
          </button>
        </div>
      )}
      {
        <ModalContent
          SetShowModal={setShowServicePartModal}
          ShowModal={showServicePartModal}
          Title={translations?.ModalHeader}
          Content={() => <div>{translations?.ModalText}</div>}
          Link={() => (
            <a href={servicePartsModalLink} target="_blank" rel="noreferrer">
              {translations?.ServicePartsModalLinkText}
            </a>
          )}
        />
      }
      {
        <ModalContent
          SetShowModal={setShowServicePartRepairModal}
          ShowModal={showServicePartRepairModal}
          Title={translations?.ServicePartsRepairHeader}
          Content={() => <div>{translations?.ServicePartsRepairText}</div>}
          Link={() => (
            <a href={servicePartsModalLink} target="_blank" rel="noreferrer">
              {translations?.ServicePartsModalLinkText}
            </a>
          )}
        />
      }
      <div className="cartButtonContainer">{getButtonBasedOnType(sparePart)}</div>
    </div>
  );
};
export default SparePartAddToCartButton;
